// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CsXQ","col":"styles_col__2ec8D","actions":"styles_actions__2HRYM","conflict":"styles_conflict__3AYe9"};